
export const center = [-8.8742, 125.7275]; //Default to Timor-Leste
export const INITIAL_VIEW_STATE = {
    zoom: 7,
};

export const styleStrike = {
    color: "#80ff00",
    weight: 1,
    opacity: 1,
    fillOpacity: 1,
    fillColor: '#80ff00'
};

export const styleDip = {
    color: "#00ffd9",
    weight: 1,
    opacity: 1,
    fillOpacity: 1,
    fillColor: '#00ffd9'
};

export const styleDepth = {
    color: "#450061",
    weight: 1,
    opacity: 1,
    fillOpacity: 1,
    fillColor: '#450061'
};
export const styleTectonicPlate = {
    color: "#ff5500",
    weight: 3,
    opacity: 1,
    fillOpacity: 1,
    fillColor: '#ff5500'
};

export function compute_magnitude(magnitude) {
    var ret = {};
    var multiplier;
    var color = '#000';
    magnitude = Math.round((magnitude ) * 10) / 10;
    if      (magnitude >= 6.5) { color = "#ff0000"; multiplier = 4; }
    else if (magnitude >= 6.0) { color = "#FF7D11"; multiplier = 3; }
    else if (magnitude >= 5.0) { color = "#0055BB"; multiplier = 2; }
    else                       { color = "#4C9E00"; multiplier = 1; }
    ret.magnitude = multiplier * parseFloat(magnitude) * 2000;
    
    ret.color = color;
   
    return ret;
}
export function compute_magnitudeUSGS(magnitude) {
    var ret = {};
    var color = '#000';
    var multiplier;
    magnitude = Math.round((magnitude ) * 10) / 10;
    if(magnitude >= 2.5 && magnitude <= 4) { color ="green"; multiplier = 1;  }
    else if(magnitude > 4.0 && magnitude <= 4.9) { color ="#dede14"; multiplier = 2;  }
    else if(magnitude >= 5.0 && magnitude <= 5.9) { color ="#00008b"; multiplier = 3; }
    else if(magnitude >= 6.0 && magnitude <= 6.9) { color ="#FF7D11"; multiplier = 4; }
    else if(magnitude >= 7.0 ) { color ="#8b0000"; multiplier = 5; }
    ret.magnitude = multiplier * parseFloat(magnitude) * 2000;;
    ret.color = color;
    return ret;
}
export function getColor(mag) {
    const t = compute_magnitude(parseFloat(mag));
    return t.color;
}
export function getColorUSGS(mag) {
    const t = compute_magnitudeUSGS(parseFloat(mag));
    return t.color;
}
export function getRGB(color){

    var ncolor = "255, 255, 255";
    if      (color === "#ff0000") { ncolor = "252, 129, 129"    ; }
    else if (color === "#FF7D11") { ncolor = "247, 181, 126" ; }
    else if (color === "#0055BB") { ncolor = "120, 179, 250"   ; }
    else                         { ncolor = "124, 173, 78"   ; }

    return ncolor;
}

export const styleUnitSources = {
    color: "#fff",
    weight: 1,
    opacity: 1,
    fillOpacity: 1,
    fillColor: '#0d4dff'
};
// Haversine formula.
export function getDistance(lat2, lon2) {
    const lat1 = -8.8218;
    const lon1 = 125.8546;
    const R = 6371; // Radius of the Earth in km
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const result = R * c;

    return formatDistance(result.toFixed(2)); // Distance in km
}
const formatDistance = (km) => {
    return new Intl.NumberFormat("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(km) + " km";
};

export function formatTimorDate(date, format = 'dmytime') {
  const d = new Date(date);
  if (isNaN(d)) return 'Invalid Date';

  const day = d.getDate().toString().padStart(2, '0');
  const month = d.toLocaleString('en-US', { month: 'short' });
  const year = d.getFullYear();

  const hours = d.getHours() % 12 || 12;
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');
  const ampm = d.getHours() >= 12 ? 'PM' : 'AM';

  switch (format) {
    case 'iso':
      return d.toISOString().split('T')[0];
    case 'long':
      return d.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      });
    case 'dmy':
      return `${day} ${month} ${year}`;
    case 'dmytime':
      return `${day} ${month} ${year} ${hours}:${minutes}:${seconds} ${ampm}`;
    default:
      return `${day}-${month}-${year}`;
  }
}